import { Controller } from "@hotwired/stimulus"

// Copies a provided text value to the clipboard
export default class extends Controller {
  static values = { text: String }

  async copy(event) {
    event.preventDefault()
    const text = this.textValue
    if (!text) return

    try {
      await navigator.clipboard.writeText(text)
      this.flash("Copied!")
    } catch (error) {
      this.flash("Copy failed")
      console.error("Clipboard copy failed", error)
    }
  }

  flash(message) {
    const original = this.element.innerHTML
    this.element.innerHTML = message
    setTimeout(() => {
      this.element.innerHTML = original
    }, 1200)
  }
}
